import {
  formatBoolean,
  formatCurrency,
  formatNumber,
  formatPercentage,
} from "@/helpers/formatter.js"

export const EM_DASH = "—"

export function formatEuro(value, precision = 2) {
  if (value == null) {
    return EM_DASH
  }
  return formatCurrency(value, "EUR", precision)
}

function formatWithUnit(value, unit) {
  if (value == null) {
    return EM_DASH
  }
  return `${formatNumber(value, 0)} ${unit}`
}

export function formatBreakdownAmount(item) {
  if (item.amount == null) {
    return EM_DASH
  }
  if (item.isVolume) {
    return formatWithUnit(item.amount, "kWh")
  }
  if (item.isPower) {
    return formatWithUnit(item.amount, "kW")
  }
  if (item.isRate4) {
    return formatEuro(item.amount, 4)
  }
  if (item.isPercentage) {
    return formatPercentage(item.amount, 2)
  }
  return formatEuro(item.amount)
}

export function formatDetailCell(value, column) {
  if (value == null) {
    return EM_DASH
  }
  switch (column.format) {
    case "euro":
      return formatNumber(value, 2)
    case "euroPrecise":
      return formatNumber(value, 4)
    case "euroMWh":
      return formatNumber(value * 1000, 0)
    case "volume":
      return formatNumber(value, 0)
    case "volumePrecise":
      return formatNumber(value, 2)
    case "percentage":
      return formatNumber(value * 100, 2)
    case "boolean":
      return formatBoolean(value)
    default:
      return value
  }
}
